import {NgModule} from "@angular/core";
import {provideNgxMask} from "ngx-mask";

import { TranslocoModule} from "@jsverse/transloco";
import { SuggestionSidebarComponent } from "./suggestion-sidebar.component";
import { CoreDirectivesModule } from "@core/directives/directives";
import { LhSuggestionContentComponent } from "./lh-suggestion-content/lh-suggestion-content.component";



@NgModule({
    declarations: [
        SuggestionSidebarComponent,
        LhSuggestionContentComponent
    ],
    imports: [
        TranslocoModule,
        CoreDirectivesModule
    ],
    exports: [
        SuggestionSidebarComponent,
        LhSuggestionContentComponent
    ],
    providers: [provideNgxMask({ validation: false })],
})
export class SuggestionSideBarModule {}
